import Menu from '@mui/material/Menu';
import styled from '@mui/material/styles/styled';
import PropTypes from 'prop-types';

const MENU_ITEM_MAX_HEIGHT = 250;

const ORIGIN = {
  ANCHOR: { vertical: 'bottom', horizontal: 'left' },
  TRANSFORM: { vertical: 'top', horizontal: 'left' },
};

const StyledMenu = styled(Menu)({
  maxHeight: MENU_ITEM_MAX_HEIGHT,
});

const Dropdown = ({ children, anchorEl, onClose, ...restProps }) => {
  return (
    <StyledMenu
      anchorEl={anchorEl}
      anchorOrigin={ORIGIN.ANCHOR}
      transformOrigin={ORIGIN.TRANSFORM}
      open={Boolean(anchorEl)}
      onClose={onClose}
      getcontentanchorel={null}
      keepMounted
      {...restProps}
    >
      {children}
    </StyledMenu>
  );
};

Dropdown.propTypes = {
  children: PropTypes.node,
  anchorEl: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.instanceOf(Element),
  ]),
  onClose: PropTypes.func.isRequired,
};

export default Dropdown;
